//--------------------------------------------------------------------------------------------------------------------------------------------------------------
// Global consts
//--------------------------------------------------------------------------------------------------------------------------------------------------------------
const prefixClass = '.at-sidebar-menu';
export const sidebarMenu = document.querySelector(prefixClass);
export const sidebarMobileMenu = document.querySelector(`${prefixClass}__mobile`);
export const sidebarMenuToggleButton = document.querySelector(`${prefixClass}__button-toggle`);
export const sidebarMenuAlphaBackground = document.querySelector(`${prefixClass}__alpha-bg`);
export const sidebarMobileMenuLevel1 = document.querySelector(`${prefixClass}__mobile-level1`);
export const sidebarMobileMenuLevel2List = document.querySelectorAll(`${prefixClass}__mobile-level2`);
export const sidebarMobileMenuScrollContainerList = document.querySelectorAll(`${prefixClass}__mobile-scroll-container`);

export const atGrowlerBtn = document.querySelector('.at-growler__button');
export const atGrowler = document.querySelector('#at-growler');
export const atHeaderElements = {
  globalMenuToggle: document.querySelector('.at-menu__button-toggle'),
  navLogo: document.querySelector('.at-main-header-nav__logo'),
  loginBtn: document.querySelector('.at-main-header-login > .at-btn'),
  userProfileBtn: document.querySelector('.at-main-header-login > .at-btn--tertiary'),
  webSearchBtn: document.getElementById('web-search-button'),
};

export const atBody = document.querySelector('.at-body');
export const documentHeader = document.querySelector('header');
export const sidebarMenuLevels = {
  0: () => {},
  1: () => sidebarMobileMenuLevel1,
  2: () => document.querySelector(`${prefixClass}__mobile .at-sidebar-menu__mobile-level2.active`),
};